
import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ComponentModel } from 'src/app/models/maintenance/component.model';
import { ElementModel } from 'src/app/models/maintenance/element.model';
import { MaintenanceRoutineModel } from 'src/app/models/maintenance/maintenance-routine.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceRoutineSupplyService } from 'src/app/services/maintenance/maintenance-routine-supply.service';
import { MaintenanceRoutineService } from 'src/app/services/maintenance/maintenance-routine.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CopyMaintenanceRoutineComponent } from '../copy-maintenance-routine/copy-maintenance-routine.component';
import { MaintenanceRoutineSupplyComponent } from '../../maintenance-routine-supply/maintenance-routine-supply/maintenance-routine-supply.component';
import { FormatModel } from 'src/app/models/formats/format.model';
import { FormatService } from 'src/app/services/formats/format.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { MaintenanceRoutinePrintModel } from 'src/app/models/print/maintenance/maintenance-routine-print.model';

@Component({
  selector: 'app-register-maintenance-routine',
  templateUrl: './register-maintenance-routine.component.html',
  styleUrls: ['./register-maintenance-routine.component.scss'],
  standalone: false
})
export class RegisterMaintenanceRoutineComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formatService = inject(FormatService);
  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly maintenanceRoutineService = inject(MaintenanceRoutineService);
  private readonly maintenanceRoutineSupplyService = inject(MaintenanceRoutineSupplyService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  @ViewChild('suppliesModal') suppliesModalComponent?: CustomModalComponent | null = null;
  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('copyModal') copyModalComponent?: CustomModalComponent | null = null;

  componentTableSelection = CustomTableSelectComponent;
  componentCopyMaintenanceRoutine = CopyMaintenanceRoutineComponent;
  ascendant: boolean = true;
  articleId: number = 0;
  articleObject = {
    code: 0,
    alterCode: "",
    name: ""
  };
  columnSort: string | null = null;
  companyId: number = 0;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  disabledForm: boolean = false;
  finishLoadingPrint: boolean = false;
  formMaintenanceRoutine: FormGroup = new FormGroup({});
  filters: ColumnResponseModel[] = [];
  formatModel: FormatModel = new FormatModel();
  headerArticle: ColumnResponseModel[] = [];
  inputsForSupplies$ = new BehaviorSubject<any>({
    maintenanceRoutineModel: new MaintenanceRoutineModel(),
    articleObject: this.articleObject
  });
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  inputsForCopy$ = new BehaviorSubject<any>({
    maintenanceRoutineModel: new MaintenanceRoutineModel()
  });
  limit: number = 5;
  maintenanceRoutineContract: MaintenanceRoutineModel = new MaintenanceRoutineModel();
  maintenanceRoutinePrintContract: MaintenanceRoutinePrintModel = new MaintenanceRoutinePrintModel();
  maintenanceRoutineId: number = 0;

  nameWindow: string = 'Rutina de Mantenimiento';
  iconState: string = "lock_open";
  isOpened: string | undefined = undefined;
  page: number = 1;
  output$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityComponents: number = 0;
  severityState: string = 'danger';
  stateText: string = 'Abierta';
  subscription: Subscription;
  suppliesRoutineComponent = MaintenanceRoutineSupplyComponent;
  titleState: string = 'Cerrar';
  url: string = 'maintenance-routine';

  selectedComponent: ComponentModel = new ComponentModel();
  selectedElement: ElementModel = new ElementModel();

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.maintenanceRoutineId = Object.keys(params).length > 0 ? params?.id : null;
    });

    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForMaintenanceRoutineAsync()]
    );

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChange(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        case 'updateRegister':
          this.getMaintenanceRoutineById();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.validateForm(this.maintenanceRoutineContract);
    await this.getPermission();
    this.handleInitialState();


  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    this.subscription.unsubscribe();
  }

  async changeState() {
    const { active, maintenanceRoutineId } = this.maintenanceRoutineContract;
    if (!maintenanceRoutineId || maintenanceRoutineId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una rutina de mantenimiento.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la rutina de mantenimiento.
          Comuníquese con el administrador del sistema.`);
      return;
    }

    if (!active) {
      const quantity = await this.getQuantitySupplies()
      if (quantity == 0) {
        const accepted = await this.confirmDialogService.confirm(`La rutina de mantenimiento no tiene insumos asociados, ¿Realmente desea cerrar la rutina de mantenimiento?`);
        if (!accepted) {
          return;
        }
      }
    }

    const response = await firstValueFrom(this.maintenanceRoutineService.setActiveAsync(maintenanceRoutineId));
    this.maintenanceRoutineContract = response;
    this.validateForm(this.maintenanceRoutineContract);
    this.toastHandlerService.showToast('success', 'La rutina fue modificada exitosamente.');
  }

  changeComponent(component: ComponentModel) {
    this.selectedComponent = component;
    this.selectedElement = new ElementModel();
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear rutinas de mantenimiento.
            Comuníquese con el administrador del sistema.`);
      return;
    }
    this.maintenanceRoutineId = 0;
    this.maintenanceRoutineContract = new MaintenanceRoutineModel();
    this.validateForm(this.maintenanceRoutineContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar rutinas de mantenimiento.
          Comuníquese con el administrador del sistema.`);
      return;
    } else if (this.maintenanceRoutineContract.active) {
      this.toastHandlerService.showToast('error', 'No es posible eliminar, la rutina de mantenimiento se encuentra cerrada.', 'Atención');
      return;
    } else if (!this.maintenanceRoutineId || this.maintenanceRoutineId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una rutina de mantenimiento.');
      return;
    }

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar la rutina de mantenimiento?');
    if (accepted) {
      try {
        await firstValueFrom(this.maintenanceRoutineService.deleteMaintenanceRoutine(this.maintenanceRoutineContract.maintenanceRoutineId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La rutina de mantenimiento fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la rutina de mantenimiento.', error);
      }
    }
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getMaintenanceRoutineByArticleAsync(articleId: number) {
    if (!articleId || this.maintenanceRoutineContract.articleId === articleId) { return; }
    try {
      const response = await firstValueFrom(this.maintenanceRoutineService.getMaintenanceRoutineByArticleAsync(articleId));
      this.maintenanceRoutineId = response.maintenanceRoutineId;
      this.maintenanceRoutineContract = response;
      this.validateForm(this.maintenanceRoutineContract);

      if (this.maintenanceRoutineId != 0) {
        this.location.replaceState(`/${this.url}/register/${this.maintenanceRoutineId}`);
      } else {
        this.location.replaceState(`/${this.url}/register`);
      }
      this.selectedComponent = new ComponentModel();
      this.selectedElement = new ElementModel();

    } catch (error) {
      console.error('Error al buscar la rutina de mantenimiento por código.', error);
    }
  }

  async getArticle(articleId: number | null) {
    if (articleId != null && articleId != 0) {
      const article = await firstValueFrom(this.maintenanceRoutineService.getArticleById(articleId));
      if (article) {
        this.articleId = articleId;
        this.articleObject = article;
      } else {
        this.articleId = 0;
        this.articleObject = { code: 0, alterCode: "", name: "Error al buscar el equipo" }
        return;
      }
    } else {
      this.articleId = 0;
      this.articleObject = { code: 0, alterCode: "", name: "" }
    }
  }

  async getArticlesForMaintenanceRoutineAsync() {
    try {
      this.dataArticle = await firstValueFrom(this.maintenanceRoutineService.getArticlesForMaintenanceRoutineAsync(this.page, this.limit, this.columnSort, this.ascendant, this.filters));

      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length == 0) {
        this.headerArticle = await firstValueFrom(this.maintenanceRoutineService.GetColumnsForArticlesAsync());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.maintenanceRoutine));
  }


  async getMaintenanceRoutineById() {
    try {
      const response = await firstValueFrom(this.maintenanceRoutineService.getMaintenanceRoutineById(this.maintenanceRoutineId));
      this.maintenanceRoutineContract = response;
      this.validateForm(response);
      this.location.replaceState(`/${this.url}/register/${this.maintenanceRoutineId}`);
    } catch (error) {
      console.error('Error al obtener la rutina de mantenimiento por id.', error);
    }
  }

  async getQuantitySupplies() {
    return await firstValueFrom(this.maintenanceRoutineSupplyService.getQuantitySupplies(this.maintenanceRoutineId));
  }

  async getMaintenanceRoutinePrint() {
    try {
      this.maintenanceRoutinePrintContract = await firstValueFrom(this.maintenanceRoutineService.getMaintenanceRoutinePrint(this.maintenanceRoutineId, this.companyId, 0));
    } catch (error) {
      console.error("Error al obtener la rutina de mantenimiento:", error);
      this.maintenanceRoutinePrintContract = new MaintenanceRoutinePrintModel();
    }
  }

  async handleInitialState() {
    if (this.maintenanceRoutineId !== null && this.maintenanceRoutineId !== 0) {
      await this.getMaintenanceRoutineById();
    } else {
      this.createNewRegister();
      this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.getMaintenanceRoutineByArticleAsync(articleId)
  }


  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.companyId = response.companyId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getArticlesForMaintenanceRoutineAsync();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openArticleSelectionModal() {
    this.filters = [];
    this.updateInputs();
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForMaintenanceRoutineAsync()]
    );
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  async openSuppliesModal() {
    if (this.maintenanceRoutineId == 0) {
      this.toastHandlerService.showToast('warning', `Debe crear una rutina de mantenimiento.`, 'Atención.');
      return;
    } else if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para ver los insumos.
          Comuníquese con el administrador del sistema.`);
      return;
    }

    this.inputsForSupplies$.next({
      maintenanceRoutineModel: this.maintenanceRoutineContract,
      articleObject: this.articleObject
    });
    this.suppliesModalComponent?.show();
  }

  async openCopyMaintenanceRoutine() {
    if (this.maintenanceRoutineId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una rutina de mantenimiento.', 'Atención');
      return;
    } else if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para copiar rutinas de mantenimiento.
          Comuníquese con el administrador del sistema.`);
      return;
    } else if (this.quantityComponents > 0) {
      this.toastHandlerService.showToast('error', 'No es posible copiar, la rutina de mantenimiento tiene componentes asociados.', 'Atención');
      return;
    }

    this.inputsForCopy$.next({
      maintenanceRoutineModel: this.maintenanceRoutineContract
    });
    this.copyModalComponent && this.copyModalComponent.show();
  }

  async printPage() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar rutinas de mantenimiento. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (this.maintenanceRoutineContract.maintenanceRoutineId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear la rutina de mantenimiento.'
      );
      return;
    }

    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();

    try {
      this.maintenanceRoutinePrintContract = await firstValueFrom(this.maintenanceRoutineService.getMaintenanceRoutinePrint(this.maintenanceRoutineId, this.companyId, 0));
      this.finishLoadingPrint = false;
      await this.waitForComponenteImpresionToLoad();
    } catch (error) {
      console.error("Error al obtener la rutina de mantenimiento:", error);
      this.maintenanceRoutinePrintContract = new MaintenanceRoutinePrintModel();
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send(): Promise<any> {
    this.validateFormControls();
    if (this.formMaintenanceRoutine.valid) {
      const modelChargeAccount = this.formMaintenanceRoutine.getRawValue();
      if (this.maintenanceRoutineId == 0) {
        try {
          const response = await firstValueFrom(this.maintenanceRoutineService.createMaintenanceRoutine(modelChargeAccount));
          this.toastHandlerService.showToast(
            'success',
            'La rutina de mantenimiento fue creada exitosamente.'
          );
          this.maintenanceRoutineContract = response;
          this.maintenanceRoutineId = this.maintenanceRoutineContract.maintenanceRoutineId;
          this.validateForm(this.maintenanceRoutineContract);
          this.location.replaceState(`/maintenance-routine/register/${this.maintenanceRoutineId}`);
        } catch (error) {
          console.error('Error al crear la rutina de mantenimiento.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast('warning', 'El campo artículo es obligatorio.');
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filters,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  updateFormState() {
    if (this.maintenanceRoutineContract.active) {
      this.titleState = 'Abrir';
      this.severityState = 'success';
      this.stateText = 'Cerrada';
      this.iconState = 'pi pi-lock-open'
      setTimeout(() => this.formMaintenanceRoutine.disable());
      this.disabledForm = true;
    } else {
      this.disabledForm = false;
      this.titleState = 'Cerrar';
      this.severityState = 'danger';
      this.stateText = 'Abierta';
      this.iconState = 'pi pi-lock'
      setTimeout(() => {
        this.formMaintenanceRoutine.enable()
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formMaintenanceRoutine.disable());
    }
  }

  async validateForm(maintenanceRoutine: MaintenanceRoutineModel) {
    this.formMaintenanceRoutine = this.formBuilder.group({
      articleId: [maintenanceRoutine.articleId, [Validators.required, Validators.min(1)]],
      active: [maintenanceRoutine.active]
    });
    await this.getArticle(maintenanceRoutine.articleId);
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formMaintenanceRoutine.controls).forEach((key) => {
      const control = this.formMaintenanceRoutine.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();

          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}
